import * as screenfull from 'screenfull';
import {
    all, call, put, select, takeLatest,
} from 'redux-saga/effects';

import {
    closeWorkspaceOverlay, featuresDoneSetup, loadWorkspacePreset, resetActiveOverlay, resetContextRequiredProperties,
} from 'common/store/workspaces/actions';
import { WorkspaceTypeKeys } from 'common/store/workspaces/types';
import { WorkspacesState } from 'common/store/workspaces/reducer';

import commonApiService from 'common/services/api/commonApiService';
import { ContextTypeKeys } from '../context/types';
import { getWorkspaceState } from '../context/sagas';
import { ContextState } from '../context/reducer';

const getContextState = (state: { context: any }) => state.context;

function* callFetchWorkspace() {
    const contextState: ContextState = yield select(getContextState);
    const workspacesState: WorkspacesState = yield select(getWorkspaceState);

    const { workspaceId } = contextState;
    const { workspaceOverlay, activeOverlay } = workspacesState;

    try {
        if (workspaceId) {
            yield put(loadWorkspacePreset(null));
            yield put(resetContextRequiredProperties());
            /*  when workspaceId updated from side bar,
                closeWorkspaceOverlay should not be called all the time unless there is an overlay related to workspaceId,
                like the columnsPicker overlay
            */
            if (workspaceOverlay && workspaceOverlay.workspaceOverlayName.includes(workspaceId)) {
                yield put(closeWorkspaceOverlay());
            }

            if (activeOverlay) {
                yield put(resetActiveOverlay());
            }
            const data = yield call(commonApiService.fetchWorkspace, workspaceId);
            yield put(loadWorkspacePreset(data));
        }
    } catch (error) {
        console.error(error);
        yield put({ error, type: 'FETCH_WORKSPACE_FAILED' });
        yield put(loadWorkspacePreset(null));
    }
}

function* callFullScreenChange() {
    const workspacesState: WorkspacesState = yield select(getWorkspaceState);

    const { fullScreenMode } = workspacesState;

    if (screenfull.enabled) {
        if (fullScreenMode) {
            screenfull.request();
        } else {
            screenfull.exit();
        }
    }
}

function* callFeatureSetupDone() {
    const workspacesState: WorkspacesState = yield select(getWorkspaceState);
    const { featuresCount } = workspacesState;

    if (featuresCount <= 0) {
        yield put(featuresDoneSetup());
    }
}
function* callClosedCommitteeOverlay() {
    yield put(closeWorkspaceOverlay());
}
function* watchWorkspaceIdChange() {
    yield takeLatest(ContextTypeKeys.WORKSPACE_ID_UPDATED, callFetchWorkspace);
}

function* watchFullScreenChange() {
    yield takeLatest(WorkspaceTypeKeys.TOGGLE_FULL_SCREEN, callFullScreenChange);
}

function* watchFeatureLoaded() {
    yield takeLatest(WorkspaceTypeKeys.FEATURE_LOADED, callFeatureSetupDone);
}

function* workspaceOverlayWatcher() {
    yield takeLatest(ContextTypeKeys.COMMITTEE_ID_SELECTED, callClosedCommitteeOverlay);
}
export function* rootWorkspacesSaga() {
    yield all([
        watchFeatureLoaded(),
        watchWorkspaceIdChange(),
        watchFullScreenChange(),
        workspaceOverlayWatcher(),
    ]);
}
